module.exports = {"Type":"CallScenario","Fields":[{"label":"Scenario Name","type":"scenario","name":"text","serializeTo":"q"}],"Header":{"Color":"white","BackgroundColor":"cornflowerblue","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/CallScenario.json
// module id = 683
// module chunks = 0